import React from 'react';

export const StatTile = ({ label, value, detail }) => (
    <div className={'sim-stat'}>
        <div className={'sim-stat-value'}>{value}</div>
        <div className={'sim-stat-label'}>{label}</div>
        {detail && <div className={'sim-stat-detail'}>{detail}</div>}
    </div>
);
